// source: psi.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.psi_proto.Request', null, global);
goog.exportSymbol('proto.psi_proto.Response', null, global);
goog.exportSymbol('proto.psi_proto.ServerSetup', null, global);
goog.exportSymbol('proto.psi_proto.ServerSetup.BloomFilterInfo', null, global);
goog.exportSymbol('proto.psi_proto.ServerSetup.DataStructureCase', null, global);
goog.exportSymbol('proto.psi_proto.ServerSetup.GCSInfo', null, global);
goog.exportSymbol('proto.psi_proto.ServerSetup.RawInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.psi_proto.ServerSetup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.psi_proto.ServerSetup.oneofGroups_);
};
goog.inherits(proto.psi_proto.ServerSetup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.psi_proto.ServerSetup.displayName = 'proto.psi_proto.ServerSetup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.psi_proto.ServerSetup.RawInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.psi_proto.ServerSetup.RawInfo.repeatedFields_, null);
};
goog.inherits(proto.psi_proto.ServerSetup.RawInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.psi_proto.ServerSetup.RawInfo.displayName = 'proto.psi_proto.ServerSetup.RawInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.psi_proto.ServerSetup.GCSInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.psi_proto.ServerSetup.GCSInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.psi_proto.ServerSetup.GCSInfo.displayName = 'proto.psi_proto.ServerSetup.GCSInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.psi_proto.ServerSetup.BloomFilterInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.psi_proto.ServerSetup.BloomFilterInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.psi_proto.ServerSetup.BloomFilterInfo.displayName = 'proto.psi_proto.ServerSetup.BloomFilterInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.psi_proto.Request = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.psi_proto.Request.repeatedFields_, null);
};
goog.inherits(proto.psi_proto.Request, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.psi_proto.Request.displayName = 'proto.psi_proto.Request';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.psi_proto.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.psi_proto.Response.repeatedFields_, null);
};
goog.inherits(proto.psi_proto.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.psi_proto.Response.displayName = 'proto.psi_proto.Response';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.psi_proto.ServerSetup.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.psi_proto.ServerSetup.DataStructureCase = {
  DATA_STRUCTURE_NOT_SET: 0,
  RAW: 1,
  GCS: 2,
  BLOOM_FILTER: 3
};

/**
 * @return {proto.psi_proto.ServerSetup.DataStructureCase}
 */
proto.psi_proto.ServerSetup.prototype.getDataStructureCase = function() {
  return /** @type {proto.psi_proto.ServerSetup.DataStructureCase} */(jspb.Message.computeOneofCase(this, proto.psi_proto.ServerSetup.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.psi_proto.ServerSetup.prototype.toObject = function(opt_includeInstance) {
  return proto.psi_proto.ServerSetup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.psi_proto.ServerSetup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.toObject = function(includeInstance, msg) {
  var f, obj = {
raw: (f = msg.getRaw()) && proto.psi_proto.ServerSetup.RawInfo.toObject(includeInstance, f),
gcs: (f = msg.getGcs()) && proto.psi_proto.ServerSetup.GCSInfo.toObject(includeInstance, f),
bloomFilter: (f = msg.getBloomFilter()) && proto.psi_proto.ServerSetup.BloomFilterInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.psi_proto.ServerSetup}
 */
proto.psi_proto.ServerSetup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.psi_proto.ServerSetup;
  return proto.psi_proto.ServerSetup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.psi_proto.ServerSetup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.psi_proto.ServerSetup}
 */
proto.psi_proto.ServerSetup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.psi_proto.ServerSetup.RawInfo;
      reader.readMessage(value,proto.psi_proto.ServerSetup.RawInfo.deserializeBinaryFromReader);
      msg.setRaw(value);
      break;
    case 2:
      var value = new proto.psi_proto.ServerSetup.GCSInfo;
      reader.readMessage(value,proto.psi_proto.ServerSetup.GCSInfo.deserializeBinaryFromReader);
      msg.setGcs(value);
      break;
    case 3:
      var value = new proto.psi_proto.ServerSetup.BloomFilterInfo;
      reader.readMessage(value,proto.psi_proto.ServerSetup.BloomFilterInfo.deserializeBinaryFromReader);
      msg.setBloomFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.psi_proto.ServerSetup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.psi_proto.ServerSetup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.psi_proto.ServerSetup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRaw();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.psi_proto.ServerSetup.RawInfo.serializeBinaryToWriter
    );
  }
  f = message.getGcs();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.psi_proto.ServerSetup.GCSInfo.serializeBinaryToWriter
    );
  }
  f = message.getBloomFilter();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.psi_proto.ServerSetup.BloomFilterInfo.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.psi_proto.ServerSetup.RawInfo.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.psi_proto.ServerSetup.RawInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.psi_proto.ServerSetup.RawInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.RawInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
encryptedElementsList: msg.getEncryptedElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.psi_proto.ServerSetup.RawInfo}
 */
proto.psi_proto.ServerSetup.RawInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.psi_proto.ServerSetup.RawInfo;
  return proto.psi_proto.ServerSetup.RawInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.psi_proto.ServerSetup.RawInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.psi_proto.ServerSetup.RawInfo}
 */
proto.psi_proto.ServerSetup.RawInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addEncryptedElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.psi_proto.ServerSetup.RawInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.psi_proto.ServerSetup.RawInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.RawInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncryptedElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes encrypted_elements = 1;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.getEncryptedElementsList = function() {
  return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes encrypted_elements = 1;
 * This is a type-conversion wrapper around `getEncryptedElementsList()`
 * @return {!Array<string>}
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.getEncryptedElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getEncryptedElementsList()));
};


/**
 * repeated bytes encrypted_elements = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEncryptedElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.getEncryptedElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getEncryptedElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.psi_proto.ServerSetup.RawInfo} returns this
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.setEncryptedElementsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.psi_proto.ServerSetup.RawInfo} returns this
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.addEncryptedElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.psi_proto.ServerSetup.RawInfo} returns this
 */
proto.psi_proto.ServerSetup.RawInfo.prototype.clearEncryptedElementsList = function() {
  return this.setEncryptedElementsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.psi_proto.ServerSetup.GCSInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.psi_proto.ServerSetup.GCSInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.GCSInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
div: jspb.Message.getFieldWithDefault(msg, 1, 0),
hashRange: jspb.Message.getFieldWithDefault(msg, 2, 0),
bits: msg.getBits_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.psi_proto.ServerSetup.GCSInfo}
 */
proto.psi_proto.ServerSetup.GCSInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.psi_proto.ServerSetup.GCSInfo;
  return proto.psi_proto.ServerSetup.GCSInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.psi_proto.ServerSetup.GCSInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.psi_proto.ServerSetup.GCSInfo}
 */
proto.psi_proto.ServerSetup.GCSInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDiv(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHashRange(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.psi_proto.ServerSetup.GCSInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.psi_proto.ServerSetup.GCSInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.GCSInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiv();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getHashRange();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getBits_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional int32 div = 1;
 * @return {number}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.getDiv = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.psi_proto.ServerSetup.GCSInfo} returns this
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.setDiv = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 hash_range = 2;
 * @return {number}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.getHashRange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.psi_proto.ServerSetup.GCSInfo} returns this
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.setHashRange = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bytes bits = 3;
 * @return {!(string|Uint8Array)}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.getBits = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes bits = 3;
 * This is a type-conversion wrapper around `getBits()`
 * @return {string}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.getBits_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBits()));
};


/**
 * optional bytes bits = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBits()`
 * @return {!Uint8Array}
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.getBits_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBits()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.psi_proto.ServerSetup.GCSInfo} returns this
 */
proto.psi_proto.ServerSetup.GCSInfo.prototype.setBits = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.psi_proto.ServerSetup.BloomFilterInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.psi_proto.ServerSetup.BloomFilterInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
numHashFunctions: jspb.Message.getFieldWithDefault(msg, 1, 0),
bits: msg.getBits_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.psi_proto.ServerSetup.BloomFilterInfo}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.psi_proto.ServerSetup.BloomFilterInfo;
  return proto.psi_proto.ServerSetup.BloomFilterInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.psi_proto.ServerSetup.BloomFilterInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.psi_proto.ServerSetup.BloomFilterInfo}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumHashFunctions(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBits(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.psi_proto.ServerSetup.BloomFilterInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.psi_proto.ServerSetup.BloomFilterInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumHashFunctions();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getBits_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional int32 num_hash_functions = 1;
 * @return {number}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.getNumHashFunctions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.psi_proto.ServerSetup.BloomFilterInfo} returns this
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.setNumHashFunctions = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bytes bits = 2;
 * @return {!(string|Uint8Array)}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.getBits = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes bits = 2;
 * This is a type-conversion wrapper around `getBits()`
 * @return {string}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.getBits_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBits()));
};


/**
 * optional bytes bits = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBits()`
 * @return {!Uint8Array}
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.getBits_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBits()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.psi_proto.ServerSetup.BloomFilterInfo} returns this
 */
proto.psi_proto.ServerSetup.BloomFilterInfo.prototype.setBits = function(value) {
  return jspb.Message.setProto3BytesField(this, 2, value);
};


/**
 * optional RawInfo raw = 1;
 * @return {?proto.psi_proto.ServerSetup.RawInfo}
 */
proto.psi_proto.ServerSetup.prototype.getRaw = function() {
  return /** @type{?proto.psi_proto.ServerSetup.RawInfo} */ (
    jspb.Message.getWrapperField(this, proto.psi_proto.ServerSetup.RawInfo, 1));
};


/**
 * @param {?proto.psi_proto.ServerSetup.RawInfo|undefined} value
 * @return {!proto.psi_proto.ServerSetup} returns this
*/
proto.psi_proto.ServerSetup.prototype.setRaw = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.psi_proto.ServerSetup.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.psi_proto.ServerSetup} returns this
 */
proto.psi_proto.ServerSetup.prototype.clearRaw = function() {
  return this.setRaw(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.psi_proto.ServerSetup.prototype.hasRaw = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional GCSInfo gcs = 2;
 * @return {?proto.psi_proto.ServerSetup.GCSInfo}
 */
proto.psi_proto.ServerSetup.prototype.getGcs = function() {
  return /** @type{?proto.psi_proto.ServerSetup.GCSInfo} */ (
    jspb.Message.getWrapperField(this, proto.psi_proto.ServerSetup.GCSInfo, 2));
};


/**
 * @param {?proto.psi_proto.ServerSetup.GCSInfo|undefined} value
 * @return {!proto.psi_proto.ServerSetup} returns this
*/
proto.psi_proto.ServerSetup.prototype.setGcs = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.psi_proto.ServerSetup.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.psi_proto.ServerSetup} returns this
 */
proto.psi_proto.ServerSetup.prototype.clearGcs = function() {
  return this.setGcs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.psi_proto.ServerSetup.prototype.hasGcs = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BloomFilterInfo bloom_filter = 3;
 * @return {?proto.psi_proto.ServerSetup.BloomFilterInfo}
 */
proto.psi_proto.ServerSetup.prototype.getBloomFilter = function() {
  return /** @type{?proto.psi_proto.ServerSetup.BloomFilterInfo} */ (
    jspb.Message.getWrapperField(this, proto.psi_proto.ServerSetup.BloomFilterInfo, 3));
};


/**
 * @param {?proto.psi_proto.ServerSetup.BloomFilterInfo|undefined} value
 * @return {!proto.psi_proto.ServerSetup} returns this
*/
proto.psi_proto.ServerSetup.prototype.setBloomFilter = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.psi_proto.ServerSetup.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.psi_proto.ServerSetup} returns this
 */
proto.psi_proto.ServerSetup.prototype.clearBloomFilter = function() {
  return this.setBloomFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.psi_proto.ServerSetup.prototype.hasBloomFilter = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.psi_proto.Request.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.psi_proto.Request.prototype.toObject = function(opt_includeInstance) {
  return proto.psi_proto.Request.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.psi_proto.Request} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.Request.toObject = function(includeInstance, msg) {
  var f, obj = {
revealIntersection: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
encryptedElementsList: msg.getEncryptedElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.psi_proto.Request}
 */
proto.psi_proto.Request.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.psi_proto.Request;
  return proto.psi_proto.Request.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.psi_proto.Request} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.psi_proto.Request}
 */
proto.psi_proto.Request.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRevealIntersection(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addEncryptedElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.psi_proto.Request.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.psi_proto.Request.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.psi_proto.Request} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.Request.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRevealIntersection();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getEncryptedElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      2,
      f
    );
  }
};


/**
 * optional bool reveal_intersection = 1;
 * @return {boolean}
 */
proto.psi_proto.Request.prototype.getRevealIntersection = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.psi_proto.Request} returns this
 */
proto.psi_proto.Request.prototype.setRevealIntersection = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated bytes encrypted_elements = 2;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */
proto.psi_proto.Request.prototype.getEncryptedElementsList = function() {
  return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * repeated bytes encrypted_elements = 2;
 * This is a type-conversion wrapper around `getEncryptedElementsList()`
 * @return {!Array<string>}
 */
proto.psi_proto.Request.prototype.getEncryptedElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getEncryptedElementsList()));
};


/**
 * repeated bytes encrypted_elements = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEncryptedElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto.psi_proto.Request.prototype.getEncryptedElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getEncryptedElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.psi_proto.Request} returns this
 */
proto.psi_proto.Request.prototype.setEncryptedElementsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.psi_proto.Request} returns this
 */
proto.psi_proto.Request.prototype.addEncryptedElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.psi_proto.Request} returns this
 */
proto.psi_proto.Request.prototype.clearEncryptedElementsList = function() {
  return this.setEncryptedElementsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.psi_proto.Response.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.psi_proto.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.psi_proto.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.psi_proto.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
encryptedElementsList: msg.getEncryptedElementsList_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.psi_proto.Response}
 */
proto.psi_proto.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.psi_proto.Response;
  return proto.psi_proto.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.psi_proto.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.psi_proto.Response}
 */
proto.psi_proto.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.addEncryptedElements(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.psi_proto.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.psi_proto.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.psi_proto.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.psi_proto.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncryptedElementsList_asU8();
  if (f.length > 0) {
    writer.writeRepeatedBytes(
      1,
      f
    );
  }
};


/**
 * repeated bytes encrypted_elements = 1;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */
proto.psi_proto.Response.prototype.getEncryptedElementsList = function() {
  return /** @type {!(Array<!Uint8Array>|Array<string>)} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * repeated bytes encrypted_elements = 1;
 * This is a type-conversion wrapper around `getEncryptedElementsList()`
 * @return {!Array<string>}
 */
proto.psi_proto.Response.prototype.getEncryptedElementsList_asB64 = function() {
  return /** @type {!Array<string>} */ (jspb.Message.bytesListAsB64(
      this.getEncryptedElementsList()));
};


/**
 * repeated bytes encrypted_elements = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEncryptedElementsList()`
 * @return {!Array<!Uint8Array>}
 */
proto.psi_proto.Response.prototype.getEncryptedElementsList_asU8 = function() {
  return /** @type {!Array<!Uint8Array>} */ (jspb.Message.bytesListAsU8(
      this.getEncryptedElementsList()));
};


/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.psi_proto.Response} returns this
 */
proto.psi_proto.Response.prototype.setEncryptedElementsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.psi_proto.Response} returns this
 */
proto.psi_proto.Response.prototype.addEncryptedElements = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.psi_proto.Response} returns this
 */
proto.psi_proto.Response.prototype.clearEncryptedElementsList = function() {
  return this.setEncryptedElementsList([]);
};


goog.object.extend(exports, proto.psi_proto);
